export const downloadRulesFile = (data) => {
    const file = new Blob([data], {type: 'text/yaml'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(file);
    link.download = 'rules.yml';
    link.click();
}